import { cn } from 'lib/utils';
import PropTypes from 'prop-types';
import Component from './component';

const Container = ({ className, children, ...props }) => {
  return (
    <Component
      className={cn('mx-auto max-w-(--breakpoint-lg) px-6', className)}
      {...props}
    >
      {children}
    </Component>
  );
};

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Container;
